import { Collapse } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
// import * as R from "ramda"
import * as React from 'react'
import { Link } from 'react-router-dom'
// import { dispatch } from '../../store'
import styles from './lecture-content.scss'
import itemStyles from './lecture-item.scss'

const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  lectureId: string
  unit: IUnit
}

interface IState {
  // unit: IUnit,
  isOpen?: boolean
}

class LectureContentChapter extends React.Component<IProps> {
  public state: IState = {
    isOpen: false
  }
  // public componentDidMount = () => { }
  // public componentWillReceiveProps = (nextProps: IProps) => { }
  public handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }
  public render() {
    const { unit, lectureId } = this.props
    // const numTrial = R.sum(
    //   unit.chapters.filter(chapter => chapter.trial).map(() => 1)
    // )
    return (
      <ul className={cx('lecture_unit')} onClick={this.handleClick}>
        {/* <div className={cx("lecture_list_unitHeader")}>
          <div className={cx("lecture_unitHeader")}>{unit.title}</div>
          <div className={cx("lecture_list_unit_toolbox")}>
            {numTrial ? (
              <div className={cx("lecture_list_trail")}>
                <Icon icon="headset" />
                {numTrial} 則試聽
              </div>
            ) : null}
            <Icon
              icon="chevron-down"
              className={cx("lecture_list_toggleUnit", {
                isOpen: this.state.isOpen
              })}
            />
          </div>
        </div> */}
        <Collapse isOpen={true}>
          {unit.chapters.map((chapter, cid) => (
            <Link
              key={`${chapter.title}-${cid}`}
              to={`/lectures/${lectureId}/content?chapterIdx=${cid}`}
            >
              <li
                className={cx('lecture_list_unit_chapter', {
                  isTrail: chapter.trial
                })}
              >
                <div className={cx('lecture_list_chapter_content')}>
                  <p className={cx('chapter_label')}>{`${cid + 1}`}.</p>
                  <p>{chapter.title}</p>
                </div>
                <div className={cx('lecture_list_chapter_toolbox')}>
                  {chapter.trial ? (
                    <div className={cx('trail_label')}>可試聽</div>
                  ) : null}
                </div>
              </li>
            </Link>
          ))}
        </Collapse>
      </ul>
    )
  }
}

export default LectureContentChapter



// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-content-chapter.tsx